import { AccessGuard } from '@/components/layout/access-guard'

export function ProtectedAdminRoute() {
  return (
    <AccessGuard
      routeId="console.root"
      deniedTitle="Console access required"
      deniedMessage="This account is valid, but it cannot use the Pelgo Console."
    />
  )
}
